import React, { useEffect, useState } from 'react'
import "./Desicions.scss"
import PersonAvatar from "../common/PersonAvatar/PersonAvatar";
import Button from "../../../partials/Button";

import StatusCircle from '../../../partials/StatusCircle';

import { OptionContainer, DecisionsQuestionAnswer } from './StyledComponents';
import { CIRCLE_STATES } from './../../../partials/StatusCircle/StatusCircle';
function Decisions({ rocketrep, teammember, decisions, onDecisionsTaken, currentParameters }) {
    const [repSpeech, setRepSpeech] = useState({
        speech: '',
        in: 0,
        out: 0,
    });

    const [teamMemberSpeech, setTeamMemberSpeech] = useState({
        speech: '',
        in: 0,
        out: 0,
    });

    const [decisionsSumary, setDecisionsSumary] = useState(() => {
        return decisions.map(d => {
            return {
                ...d,
                isSelected: false,
            }
        })
    });

    const [isComplete, setIsComplete] = useState(false);
    const [currentDecision, setCurrentDesicion] = useState();
    const [currentSelectedOption, setCurrentSelectedOption] = useState({ is_correct: false });
    const [storyStatus, setStoryStatus] = useState('initial');
    const [incorrects, setIncorrects] = useState([]);

    useEffect(() => {
        if (storyStatus !== "initial") {
            return
        }
        setRepSpeech({
            speech: 'OK, Now we have a few more decisions to make. ' +
                'I need to know more about your requirements,' +
                'including your timeline and budget. ' +
                'Ready?',
            in: 0.5,
            out: 1,
            onFinish: () => {

            }
        })
        setTeamMemberSpeech({
            speech: 'I\'ll help you remember what the relevant mission and project' +
                ' parameters are.',
            in: 1,
            out: 1.0,
            onFinish: () => {
                setStoryStatus('ready')
            }
        })
    }, []);

    useEffect(() => {
        if (!decisionsSumary) {
            return
        }
        const hasUncompleted = decisionsSumary.find(ds => ds.isSelected === false)
        if (typeof hasUncompleted === "undefined") {
            setIsComplete(true)
            return
        }
        setIsComplete(false)
    }, [decisionsSumary]);

    useEffect(() => {
        switch (storyStatus) {
            case "running":
                setTimeout(() => {
                    setCurrentDesicion(decisions[0])
                }, 200)
                break;
            default:
                break;
        }
    }, [storyStatus]);

    const handleOptionClick = (answer, index) => {

        setTeamMemberSpeech({
            speech: answer.feedback,
            in: 0.2,
            out: 2,
        });


        if (answer.is_correct === true)
            setDecisionsSumary(decisionsSumary.map(decision => {
                if (decision.caption === currentDecision.caption)
                    return {
                        ...decision,
                        isSelected: true,
                    }

                else
                    return decision
            }))
        else
            setIncorrects([...incorrects, index])

        if (answer.is_correct === true)
            setIncorrects([])

        setCurrentSelectedOption(answer)
    }

    useEffect(() => {
        if (currentDecision) {
            setTeamMemberSpeech({
                speech: '',
                in: 0,
                out: 2,
            })
            setRepSpeech({
                speech: currentDecision.rep_script,
                in: 0.2,
                out: 2,
            })
        }

    }, [currentDecision]);

    const handleOnNextDecision = () => {
        if (isComplete) {
            if (onDecisionsTaken) {
                onDecisionsTaken(decisionsSumary)
            }
        }
        const currentIndex = decisions.indexOf(currentDecision)
        if (currentIndex > -1 && currentIndex < decisions.length) {
            setCurrentSelectedOption({ is_correct: false })
            setCurrentDesicion(decisions[currentIndex + 1])

        }
    }

    const isCorrectSelected = currentSelectedOption.is_correct;

    const getCurrentDecision = (o, index) => {
        const thisIsClicked = isCorrectSelected || incorrects.some(e => e === index);
        const className = `${thisIsClicked ? "disabled" : ""}`

        let state = CIRCLE_STATES.DEFAULT;

        if (thisIsClicked || isCorrectSelected)
            if (o.is_correct)
                state = CIRCLE_STATES.CHECKED_GREEN;
            else
                state = CIRCLE_STATES.ERROR;

        return (
            <div style={{display:'inherit'}}>
            <OptionContainer
                disabled={thisIsClicked}
                is_correct={o.is_correct}
                key={o.caption}
                className={className}
                onClick={() => handleOptionClick(o, index)}>
                <DecisionsQuestionAnswer>
                    {o.caption}
                </DecisionsQuestionAnswer>

            </OptionContainer>
            <StatusCircle state={state} className="circle" />
            </div>
        )
    }

    return <div className="decisions_container">
        <img src={currentParameters.rocket.img} alt={currentParameters.rocket.name} />
        <div className={"decisions_subjects"} >
            {rocketrep && <PersonAvatar avatar={rocketrep.avatar}
                name={rocketrep.name}
                speak={repSpeech.speech}
                delayIn={repSpeech.in}
                delayOut={repSpeech.out}
                onFinishTalking={repSpeech.onFinish}
                jobtitle={rocketrep.role} />
            }
            {teammember && <PersonAvatar avatar={teammember.avatar}
                name={teammember.name}
                speak={teamMemberSpeech.speech}
                delayIn={teamMemberSpeech.in}
                delayOut={teamMemberSpeech.out}
                onFinishTalking={teamMemberSpeech.onFinish}
                jobtitle={teammember.role} />}
        </div>
        <div className="quiz_container">
            <div className={"decisions_content"}>
                {
                    currentDecision &&
                    <div className={"decisions_decision_container"} >
                        {currentDecision.options.map(getCurrentDecision)}
                    </div>
                }

            </div>
            <div className={"decisions_summary"} >
                <div className={"decisions_summary_caption"}>
                    Launch Decisions
                </div>
                {
                    decisionsSumary && decisionsSumary.map(ds => {
                        return <div key={ds.caption} className={"decisions_decision"}>
                            <div className={"decisions_decision_caption"}>
                                {ds.caption}:
                            </div>
                            <div className={"decisions_decision_value"}>
                                {ds.isSelected === true ? ds.options.find(o => o.is_correct === true).caption : 'TBD'}
                            </div>
                        </div>
                    })
                }
                <div className="button_container">
                    {
                        storyStatus === 'running' &&
                        <Button
                            text={isComplete === false ? 'NEXT' : 'COMPLETE'}
                            disabled={!currentSelectedOption.is_correct}
                            onClick={handleOnNextDecision}
                        />
                    }

                    {
                        storyStatus !== 'running' &&
                        <Button text="start" onClick={() => setStoryStatus('running')} />
                    }

                </div>

            </div>
        </div>
    </div>
}



export default Decisions
